import axios, { AxiosResponse } from 'axios' 
import { IVehicleGroupModel } from './VehicleGroupModel';
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'

// Base URL ayarı
const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

//  BASE URL 
export const VEHICLEGROUP_CREATE_URL = `${API_URL}api/v1/definition/vehicleGroup/create`;
export const VEHICLEGROUP_GET_ALL_URL = `${API_URL}api/v1/definition/vehicleGroup/all`;
export const VEHICLEGROUP_DELETE_URL = `${API_URL}api/v1/definition/vehicleGroup/delete/`;
export const VEHICLEGROUP_UPDATE_URL = `${API_URL}api/v1/definition/vehicleGroup/update/`;
export const VEHICLEGROUP_GET_BY_ID_URL = `${API_URL}api/v1/definition/vehicleGroup/getById/`
 
export function createVehicleGroup(vehicleGroupData: IVehicleGroupModel) { 
  return axios.post(VEHICLEGROUP_CREATE_URL, vehicleGroupData);
}
 
export function updateVehicleGroup(vehicleGroup: IVehicleGroupModel) {
  return axios.patch(VEHICLEGROUP_UPDATE_URL + vehicleGroup.id, vehicleGroup)
}
 
export async function loadVehicleGroups(
  page = 0, 
  size = 5, 
  sort: string = 'createdDate', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IVehicleGroupModel>>>> {
  return axios.get(VEHICLEGROUP_GET_ALL_URL, {
    params: { page, size, sort, order }
  });
}
 
export function deleteVehicleGroup(vehicleGroupId: string) {
  return axios.delete(VEHICLEGROUP_DELETE_URL+vehicleGroupId);
}

export function getVehicleGroupById(
  id: string  
): Promise<AxiosResponse<ApiResponse<IVehicleGroupModel>>>  {
  return axios.get(VEHICLEGROUP_GET_BY_ID_URL + id)
}

